
import * as XLSX from 'xlsx-js-style';

export async function generateFicheLivraison(livraison) {
    const response = await fetch("/assets/excel/Fiche_Livraison.xlsx");
    const arrayBuffer = await response.arrayBuffer();

    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    worksheet['!cols'] = [{ wch: 4 }, { wch: 13 }, { wch: 6 }, { wch: 5 }, { wch: 5 }, { wch: 23 }, { wch: 23 }, { wch: 4 }];
    worksheet['!rows'] = [{ hpt: 22 }, { hpt: 60 }, ...Array.from({ length: 15 }, () => ({ hpt: 45 }))];

    worksheet["F1"] = { t: "d", v: new Date(livraison.dateLivraison) || "" };

    livraison.commande.forEach((commande, i) => {
        const row = i + 3; // Commence à la ligne 3
        worksheet[`B${row}`] = { t: "s", v: commande.identite.nom };
        worksheet[`C${row}`] = { t: "s", v: commande.quantiteBois };
        worksheet[`D${row}`] = { t: "s", v: commande.longueurBois };
        worksheet[`F${row}`] = { t: "s", v: commande.identite.adresse.localite || "" ,s: { alignment: { wrapText: true } }};
        worksheet[`G${row}`] = { t: "s", v: commande.notes || "" };
    }
    );

    //Titre en gris
    ["A17", "D17", "D1"].forEach(cellRef => {
        if (!worksheet[cellRef]) {
            worksheet[cellRef] = { t: "s", v: "" };
        }

        worksheet[cellRef].s = {
            fill: {
                fgColor: { rgb: "D3D3D3" }
            },
            font: {
                bold: true
            },
            alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true
            }
        };
    });

    //Titre en noir
    const headerCells = ["A2", "B2", "C2", "D2", "E2", "F2", "G2", "H2"];
    headerCells.forEach(cellRef => {
        if (!worksheet[cellRef]) {
            worksheet[cellRef] = { t: "s", v: "" };
        }

        worksheet[cellRef].s = {
            fill: {
                fgColor: { rgb: "000000" }
            },
            font: {
                color: { rgb: "FFFFFF" },
                bold: true,
            },
            alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true
            }
        };
    });
    // tableau en couleur
    const colorTable = {
        fill: {
            fgColor: { rgb: "D3D3D3" }
        },
    };

    const startCol = 'A'.charCodeAt(0);
    const endCol = 'H'.charCodeAt(0);

    for (let row = 3; row <= 16; row += 2) {
        for (let colCode = startCol; colCode <= endCol; colCode++) {
            const colLetter = String.fromCharCode(colCode);
            const cellRef = `${colLetter}${row}`;

            if (!worksheet[cellRef]) {
                worksheet[cellRef] = { t: "s", v: "" };
            }

            // Appliquer le style
            worksheet[cellRef].s = {
                ...worksheet[cellRef].s,
                ...colorTable
            };
        }
    }
    // cellule avec contour
    const cellStyle = {
        font: {
            name: "Arial",
            sz: 11,
        },
        border: {
            top: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } }
        }
    };

    for (let row = 1; row <= 17; row++) {
        for (let colCode = 'A'.charCodeAt(0); colCode <= 'H'.charCodeAt(0); colCode++) {
            const colLetter = String.fromCharCode(colCode);
            const cellRef = `${colLetter}${row}`;

            // Création de la cellule si elle n'existe pas
            if (!worksheet[cellRef]) {
                worksheet[cellRef] = { t: 's', v: '' };
            }

            // Application du style
            if (!headerCells.includes(cellRef)) {
                worksheet[cellRef].s = {
                    ...worksheet[cellRef].s,
                    font: {
                        ...worksheet[cellRef].s?.font,
                        ...cellStyle.font
                    },
                    border: cellStyle.border
                };
            }
        }
    }

    workbook.Sheets[sheetName] = worksheet;

    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Livraison_${livraison.dateLivraison}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
